import React, { useState, useRef, useEffect } from 'react';

const SUGGESTIONS = [
  { text: 'Get a Print Quote 🖨️', message: "Hi! I'd like to request a quote for some custom digital printing items." },
  { text: 'Print Visiting Cards 📇', message: "Hello! I want to print visiting cards. Could you let me know the pricing and options?" },
  { text: 'Check Order Status 📦', message: "Hi! I'd like to check the status of my print order." },
  { text: 'General Enquiry 💬', message: "Hello! I have a question about your printing services and custom formats." },
];

const WhatsAppWidget: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const widgetRef = useRef<HTMLDivElement | null>(null);

  // Close widget when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (widgetRef.current && !widgetRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSuggestionClick = (msgText: string) => {
    setMessage(msgText);
  };

  const handleSend = () => {
    const defaultMsg = "Hi Prathitha Digital Printers! 👋";
    const finalMsg = message.trim() ? message : defaultMsg;
    const url = `https://wa.me/919150808130?text=${encodeURIComponent(finalMsg)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    setIsOpen(false);
    setMessage('');
  };

  return (
    <div className="whatsapp-widget-container" ref={widgetRef}>
      {/* Expanded Chatbox Panel */}
      <div className={`whatsapp-chatbox ${isOpen ? 'open' : ''}`}>
        {/* Header */}
        <div className="whatsapp-header">
          <div className="whatsapp-header-info">
            <div className="whatsapp-avatar">
              <i className="fas fa-print"></i>
              <span className="online-indicator"></span>
            </div>
            <div>
              <div className="whatsapp-company-name">Prathitha Printers</div>
              <div className="whatsapp-status">Online • Typically replies instantly</div>
            </div>
          </div>
          <button className="whatsapp-close-btn" onClick={() => setIsOpen(false)} aria-label="Close Chat">
            <i className="fas fa-times"></i>
          </button>
        </div>

        {/* Chat Messages Area */}
        <div className="whatsapp-chat-body">
          <div className="whatsapp-message-bubble incoming">
            <div className="whatsapp-sender">Support Team</div>
            <div className="whatsapp-text">
              Hello there! Welcome to Prathitha Digital Printers. 🖨️✨
              <br /><br />
              How can we assist you today? Feel free to ask about pricing, configure print runs, or track orders!
            </div>
            <div className="whatsapp-time">Just now</div>
          </div>

          {message && (
            <div className="whatsapp-message-bubble outgoing">
              <div className="whatsapp-text">{message}</div>
            </div>
          )}
        </div>

        {/* Suggestion Chips */}
        <div className="whatsapp-suggestions-container">
          <div className="whatsapp-suggestions-title">Quick Actions:</div>
          <div className="whatsapp-suggestions">
            {SUGGESTIONS.map((s, idx) => (
              <button
                key={idx}
                className="whatsapp-suggestion-chip"
                onClick={() => handleSuggestionClick(s.message)}
              >
                {s.text}
              </button>
            ))}
          </div>
        </div>

        {/* Chat Input Footer */}
        <div className="whatsapp-footer">
          <textarea
            className="whatsapp-input"
            placeholder="Type your message here..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSend();
              }
            }}
            rows={2}
          />
          <button className="whatsapp-send-btn" onClick={handleSend} aria-label="Send via WhatsApp">
            <i className="fas fa-paper-plane"></i>
          </button>
        </div>
      </div>

      {/* Floating Action Button */}
      <button
        className={`whatsapp-widget-fab ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        title="Chat with us on WhatsApp"
        aria-expanded={isOpen}
      >
        <i className="fab fa-whatsapp"></i>
        {!isOpen && <span className="whatsapp-notification-badge">1</span>}
      </button>
    </div>
  );
};

export default WhatsAppWidget;
